import { createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import {
  loadListBasketInsight,
  setHottestLists,
  updateAnalyticsExchange,
  upsertAnalyticsEntities,
  upsertAnalyticsEntityTopSellingProducts,
} from './analytics-entities.actions';
import { AnalyticsEntity, State } from './interfaces';

const adapter = createEntityAdapter<AnalyticsEntity>({
  selectId: (entity) => entity.listId,
});

export const initialState: State = adapter.getInitialState({
  basketInsightsLoading: false,
});

export const reducer = createReducer<State>(
  initialState,
  on(upsertAnalyticsEntities, (state, { entities }) => ({
    ...adapter.upsertMany(
      entities.map((entity) => ({
        ...entity,
        updateDate: new Date().toISOString(),
      })),
      state,
    ),
    basketInsightsLoading: false,
  })),
  on(updateAnalyticsExchange, (state, { exchange }) => ({
    ...state,
    exchange,
  })),
  on(setHottestLists, (state, { topLists }) => ({
    ...state,
    topLists,
  })),
  on(loadListBasketInsight, (state, { sortBy, listId }) => ({
    ...adapter.upsertOne(
      {
        listId,
        basketInsightsSort: sortBy,
      },
      state,
    ),
    basketInsightsLoading: true,
    hasError: false,
  })),
  on(upsertAnalyticsEntityTopSellingProducts, (state, { products, listId }) =>
    adapter.upsertOne({ listId, topSellingProducts: products }, state),
  ),
);
